import { usePage } from '@inertiajs/react'

export function usePanel<T>(key: string): T | undefined {
  const { props } = usePage<Record<string, unknown>>()
  return props[key] as T | undefined
}
